<script setup>
import {defineProps, inject, defineEmits} from "vue"
import {useStore} from 'vuex'
const storeFourBaseUrl = inject('storeFourBaseUrl')
const store = useStore()
const props = defineProps({
  items:{
    type: Array,
    required: true
  },
  lastOptionSelected:{
    type: Number,
    required: true
  }
})
const emit = defineEmits(["openNextMenuLevel", 'backToPrevStep'])
const closeMenu = () => {
  store.dispatch('megaMenu/closeMenu')
}
const nextLevelOpener = (parentId, level, name)=>{
  emit('openNextMenuLevel', { parent_id: parentId, level_item: level, level_name: name })
}
const getIconSrc = (image) =>{
  return `${storeFourBaseUrl}/filepond/menu/${image}`
}
const backToPrevStep = (level) =>{
  emit('backToPrevStep', level)
}
</script>
<template>
  <div>
    <v-list-item v-if="$vuetify.display.mdAndDown" @click="closeMenu" width="100%" class="d-flex justify-center">
      <v-icon size="large" icon="$mdiMinus"></v-icon>
    </v-list-item>
    <v-list-item v-if="$vuetify.display.mdAndDown" @click="backToPrevStep(1)">
      <v-icon icon="$mdiArrowRight" class="ml-2"></v-icon>
      {{ props.lastOptionSelected[0] }}
    </v-list-item>
    <v-list-subheader class="font-weight-medium mx-3 mb-2 text-right" v-if="$vuetify.display.mdAndDown">
      <span>انتخاب رشته</span>
    </v-list-subheader>
    <v-list-item class="rounded-xl my-2" v-for="(item, i) in props.items"
                 :key="i"
                 :value="item"
                 :width="$vuetify.display.mdAndDown?'100%':''"
                 @click="nextLevelOpener(item.id, 2, item.title)">
      <div class="d-flex flex-column align-items-center justify-content-start">
        <img v-if="!$vuetify.display.mdAndDown" :src="getIconSrc(item.icon_img)" width="160">
        <div class="measure-name w-100 mt-2 d-flex justify-content-between">
          <span class="font-weight-bolder">{{ item.title }}</span>
          <v-icon :icon="$vuetify.display.mdAndDown?'$mdiArrowLeft':'$chevronLeft'"></v-icon>
        </div>
      </div>
    </v-list-item>
  </div>
</template>


<style scoped>

</style>
